<template>
    <div>
        <div class="columns is-centered">
            <div class="column has-text-centered">
                <h1 class="is-size-3 has-text-white">BATCH IMPORT</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <p class="has-text-centered is-size-6 has-text-white">Your file should follow this <a href="/files/import_example.csv" download>template</a>. The serial number field must be unique and the product code must be valid.</p>
            </div>
        </div>
        <div class="columns" v-if="errorData.length > 0">
            <div class="column">
              <div class="box has-background-danger has-text-light">
                  <p>Your report submitted with errors. The following records were not successfully imported. Please adjust the records to conform to the expected format. If you continue to experience errors please contact the administrator</p>
            </div>
            </div>
        </div>        
        <div class="columns">
            <div class="column has-text-centered">
                    <div class="columns is-centered my-4">
                        <div class="column is-half box has-background-dvoalt">
                        <b-field class="file is-primary" :class="{'has-name': !!csv}">
                            <b-upload v-model="csv" class="file-label">
                                <span class="file-cta">
                                    <b-icon class="file-icon" icon="upload"></b-icon>
                                    <span class="file-label">Click to upload</span>
                                </span>
                                <span class="file-name" v-if="csv">
                                    {{ csv.name }}
                                </span>
                            </b-upload>
                        </b-field>
                        <b-button v-if="csv" class="button is-primary is-large my-4" @click="batchImport">Submit</b-button>                
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { batchHandler } from '../graphql/mutations'
import importModal from './ImportModal.vue'
export default {
    data(){
        return{
            csv: null,
            csvTable: [],
            errorData: []
        }
    },
    components:{
    },
    methods:{
        async submit(){
            try {
                await API.graphql({
                query: batchHandler,
                variables: {
                    input: {
                        request_type: 'batch_import',
                        batch_array: this.csv
                    }
                }
            })

            this.$buefy.notification.open({
                    duration: 5000,
                    message: `Successful import`,
                    position: 'is-bottom',
                    type: 'is-success',
                    hasIcon: true
            })
            
            } catch (e){
                this.$buefy.notification.open({
                    duration: 5000,
                    message: `${e}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
            }
        },
        arraysMatch(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false;
            }
            return true;
        },
        batchImport() {
            try {
            this.$papa.parse(this.csv, {
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                transformHeader: function (header) {
                    return header.trim().toLowerCase().replace(/\s/g, '_');
                },
                complete: async  (results) => {
                    if(!this.arraysMatch(results.meta.fields, ['serial', 'product_code', 'production_date', 'order_number', 'po_number'])){
                        this.$buefy.notification.open({
                                duration: 5000,
                                message: "Error: fields do not match expected fields. Please see the template" ,
                                position: 'is-bottom',
                                type: 'is-danger',
                                hasIcon: true
                        })
                    } else {
                        this.$buefy.modal.open({
                            parent: this,
                            component: importModal,
                            hasModalCard: true,
                            trapFocus: true,
                            props: {
                                importData: results.data
                            },
                            events:{
                                'importWithErrors': async()=>{
                                    console.log('importWithErrors')
                                },
                            }
                        })
                    }
                },
                error: async (error, file) => {
                    this.$buefy.notification.open({
                            message: "Error:" + error + "\n" + "File: " + file,
                            position: 'is-bottom',
                            type: 'is-danger',
                            hasIcon: true
                        })                    
                }
            })
            } catch (error) {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `${error}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
            }

        }
    }
}
</script>

<style>
   .table {
      margin-left: auto;
      margin-right: auto;
    }
</style>